export const SHOW_SWITCHED_SUPERVISED_USER_MODAL =
  'SHOW_SWITCHED_SUPERVISED_USER_MODAL';
export const HIDE_SWITCHED_SUPERVISED_USER_MODAL =
  'HIDE_SWITCHED_SUPERVISED_USER_MODAL';
